<template>
  <Container class="block max-w-308 mx-auto">
    <div class="ml-1.5 mb-4 flex justify-start">
      <ReturnButton />
    </div>

    <div
      class="size-full bg-white bg-cover bg-no-repeat rounded-8xl flex items-center justify-end p-12 bg-[position:-5px_center]"
      :style="{ backgroundImage: `url(${getImageUrl('header/user/login-bg.webp')})` }"
    >
      <AuthPanel />
    </div>
  </Container>
</template>

<script lang="ts" setup>
  import { getImageUrl } from '@/utils/assets'
  import AuthPanel from './components/AuthPanel.vue'
  import Container from '@/components/Container.vue'
  import ReturnButton from '@/components/ReturnButton.vue'
</script>

<style lang="scss" scoped></style>
